import styled from '@emotion/styled';
import { COLORS } from '~Scenes/Handy/styles';
import { Button } from '~Styles';

export const DemoIntroWrapper = styled.div`
  padding: 0 40px;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  h1 {
    color: ${COLORS.blueGray100};
  }

  p {
    color: ${COLORS.blueGray500};
  }
`;

export const DemoButton = styled(Button)`
  margin-top: 24px;
  height: 56px;
  width: 200px;
`;

export const ExitButton = styled.button`
  padding: 8px;
  margin-top: 24px;
  color: ${COLORS.blueGray100};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  letter-spacing: 1px;
`;
